import { render, staticRenderFns } from "./FourStickerPreview.vue?vue&type=template&id=39242749&"
import script from "./FourStickerPreview.vue?vue&type=script&lang=js&"
export * from "./FourStickerPreview.vue?vue&type=script&lang=js&"
import style0 from "./FourStickerPreview.vue?vue&type=style&index=0&id=39242749&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports